import { createFileRoute, Link } from "@tanstack/react-router";
import { Plus, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CustomerList } from "@/features/customers/components/customer-list";
import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useSubscription } from "@/hooks/use-subscription";
import { useCustomers } from "@/features/customers/hooks/use-customers";
import { PermissionGuard } from "@/components/auth/permission-guard";
import { PERMISSIONS } from "@/constants/permissions.constants";

export const Route = createFileRoute("/(app)/dashboard/customers/")({
  component: CustomersPage,
});

function CustomersPage() {
  const { t } = useTranslation();
  useDocumentTitle('customers.title');
  
  const { data: customers } = useCustomers();
  const { hasReachedLimit, getLimitText, level } = useSubscription();
  
  const customerCount = customers?.length || 0;
  const hasReachedCustomerLimit = hasReachedLimit('customers', customerCount);
  
  return (
    <div className="w-full max-w-full space-y-4 md:space-y-6 overflow-hidden">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight md:text-3xl">{t('customers.title')}</h1>
          <p className="text-sm text-muted-foreground md:text-base">
            {t('customers.description')}
          </p>
          {level !== 'pro' && (
            <p className="text-xs text-muted-foreground mt-1 md:text-sm">
              {getLimitText('customers', customerCount)}
            </p>
          )}
        </div>
        {hasReachedCustomerLimit ? (
          <PermissionGuard permission={PERMISSIONS.CUSTOMERS_CREATE}>
            <Button disabled className="relative w-full sm:w-auto">
              <Crown className="mr-2 h-4 w-4 text-yellow-500" />
              {t('customers.limitReached', 'Limit erreicht')}
            </Button>
          </PermissionGuard>
        ) : (
          <PermissionGuard permission={PERMISSIONS.CUSTOMERS_CREATE}>
            <Link to="/dashboard/customers/new" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto">
                <Plus className="mr-2 h-4 w-4" />
                {t('customers.newCustomer')}
              </Button>
            </Link>
          </PermissionGuard>
        )}
      </div>

      <CustomerList />
    </div>
  );
}